import { render, staticRenderFns } from "./cmm-no-data.vue?vue&type=template&id=42567cf7&scoped=true&"
import script from "./cmm-no-data.vue?vue&type=script&lang=js&"
export * from "./cmm-no-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42567cf7",
  null
  
)

export default component.exports